import "./chart.scss";

import type { FC } from "react";
import { memo } from "react";
import { Badge } from "react-bootstrap";

import { Switch } from "../Switch/Switch";

export interface IChartLabelData {
  value: string;
  color?: "#3C19CD" | "#0FAF74" | "#A347F8";
  label?: string;
}

export interface IProps {
  title: string;
  data?: IChartLabelData[];
  dataToggler?: {
    handler: (val: boolean) => void;
    value: string;
    disabled?: boolean;
  };
}

const colorMap: any = {
  "#3C19CD": "blue",
  "#0FAF74": "green",
  "#A347F8": "purple",
};

const ChartLabel: FC<IProps> = memo(({ title, data, dataToggler }) => {
  return (
    <div className="chart__label">
      <div className="chart__label__title" role="textbox" aria-label={title}>
        <span>{title}</span>
        {dataToggler && (
          <div className="switch-container">
            <Switch
              onChange={dataToggler.handler}
              label={dataToggler.value}
              checked={dataToggler.value === "Cumulative"}
              disabled={dataToggler.disabled}
            />
          </div>
        )}
      </div>
      <div className="chart__label__info">
        {data &&
          data.map((item, index) => (
            <div key={index} className="d-flex align-items-center">
              {item.value}
              {item.color && item.label && (
                <Badge
                  pill
                  className={`chart__label__badge ${colorMap[item.color]}`}
                >
                  {item.label}
                </Badge>
              )}
            </div>
          ))}
      </div>
    </div>
  );
});

export default ChartLabel;
